import styles from './Spinner.module.css';

const Spinner = (): React.ReactElement => (
  <span className={styles.spinner} role="status" aria-label="Loading" />
);

export { Spinner };
